import React from 'react';
import {Link} from 'react-router-dom';
import SubHeader from '../../../layout/components/SubHeader';
import PasswordUpdateComponent from '../../../pages/password/PasswordUpdateComponent';

function SmsChangePassword() {
    return (
        <>
            <SubHeader
                title="Change Password"
                description="Update your account password. You will be logged out after a successful change."
                icon="bi-key-fill"
                iconClass="text-secondary"
                containerClass="container-fluid px-4"
            >
                <div className="d-flex align-items-center sms-help-subheader-action">
                    <Link
                        to="/sms-clinic-settings"
                        className="btn btn-light btn-sm rounded-pill sms-help-back-link"
                    >
                        <i className="bi bi-arrow-left me-1"/>
                        Back to Settings
                    </Link>
                </div>
            </SubHeader>
            <div className="container-fluid px-4 py-3">
                <PasswordUpdateComponent />
            </div>
        </>
    );
}

export default SmsChangePassword;
